import { useUpdateCompanySizeMutation } from "@/pages/Private/redux/company-size/company-size.api";

import { CompanySize, CompanySizeSchema } from "../../schema/company-size";
import EditModeCompanySizeItem from "./EditableCompanySizeItem";
import ViewModeCompanySizeItem from "./ViewCompanySizeItem";

interface EditableCompanySizeItemProps {
	data: CompanySize;
	isEditing: boolean;
	isEditingInProcess: boolean;
	setEditing: (value: number) => void;
	setDeletingCompanySize: (value: CompanySize | null) => void;
}

export default function EditableCompanySizeItem({
	data,
	isEditing,
	setEditing,
	setDeletingCompanySize,
	isEditingInProcess,
}: EditableCompanySizeItemProps) {
	const [updateCompanySize, { isLoading }] = useUpdateCompanySizeMutation();

	const handleUpdateCompanySize = async (values: CompanySize) => {
		try {
			await updateCompanySize(values);
		} catch (error) {
			console.error("An unexpected error occurred:", error);
		}
	};

	return isEditing ? (
		<EditModeCompanySizeItem
			data={data}
			isLoading={isLoading}
			setEditing={setEditing}
			validationSchema={CompanySizeSchema}
			onSubmit={handleUpdateCompanySize}
		/>
	) : (
		<ViewModeCompanySizeItem
			data={data}
			isEditingInProcess={isEditingInProcess}
			isLoading={false}
			setDeletingCompanySize={setDeletingCompanySize}
			setIsEditing={setEditing}
		/>
	);
}
